import { Table } from 'antd';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { MaxLessonsPerDayCreate } from 'entities/max-lessons-per-day';
import { useMaxLessonsPerDayTable } from '../model';

export const MaxLessonsPerDayTable = () => {
  const {
    state: { dataSource, columns },
    methods: { refreshTable },
  } = useMaxLessonsPerDayTable();

  return (
    <AppFlex direction="column">
      <MaxLessonsPerDayCreate refreshTable={refreshTable} />
      <Table dataSource={dataSource} columns={columns} rowKey="id" bordered pagination={false} />
    </AppFlex>
  );
};
